export function normalizeSearchTerm (value: unknown): string {
  return String(value ?? '').trim().toLocaleLowerCase()
}
